import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

import {
	Button as DesignSystemButton,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	minWidth,
	TextButton,
} from '@calm-web/design-system';

export const Divider = styled.div`
	background: #c6c6c6;
	height: 1px;
	margin: 24px 0;
	width: 100%;
`;

export const HeadingContainer = styled.div`
	color: ${palette('gray7')};
	margin-top: 28px;
	text-align: center;

	${minWidth('tablet')} {
		margin-top: 0;
	}
`;

export const Heading = styled.h4`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 8px;
`;

export const Subheading = styled.p`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 8px;
`;

export const OrderSummary = styled.div`
	color: ${palette('gray7')};
	margin: 24px 0 8px;
`;

export const OrderSummaryLabel = styled.div`
	font-weight: 900;
	margin-bottom: 12px;
	text-align: left;
`;

const orderRow = css`
	color: ${palette('gray7')};
	display: flex;
	${fontSize(FontSizes.base)};
	${fontWeight(FontWeights.Light)};
	line-height: 1.5;
	margin-bottom: 8px;
	justify-content: space-between;
`;

export const OrderRow = styled.div`
	${orderRow}
`;

export const OrderRowTotal = styled.div`
	${orderRow}
	${fontWeight(FontWeights.Demi)};
`;

export const OrderRowSmall = styled.div`
	${orderRow}
	font-size: 13.5px;
`;

export const PaymentTitleWrapper = styled.div`
	align-items: flex-end;
	display: flex;
	margin-bottom: 8px;
`;

export const PaymentTitleHeading = styled.h4`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 0;
	margin-right: 8px;
`;

export const Cta = styled(TextButton)`
	color: ${palette('blue2')};
	cursor: pointer;
	${fontSize(FontSizes.base)};
	${fontWeight(FontWeights.Medium)};
	position: relative;
	top: -3px;
	text-decoration: underline;
`;

export const Copy = styled.p`
	color: ${palette('gray7')};
	${fontSize(FontSizes.base)};
	${fontWeight(FontWeights.Light)};
	line-height: 1.5;
	margin-bottom: 18px;
`;

export const ConfirmButton = styled(DesignSystemButton)`
	width: 100%;
`;
